import React from 'react'
import { Link } from 'gatsby'
import { RelatedTreatment } from '../interfeces'

interface RelatedTreatmentsProps {
  treatments: RelatedTreatment[]
  heading?: string
}

/**
 * Related Treatments Component
 *
 * Displays links to 2-3 related treatment pages for internal linking
 *
 * Contract: FR-008 - Display 2-3 related treatment links per page
 * SEO: Improves internal linking structure and site navigation
 */
const RelatedTreatments: React.FC<RelatedTreatmentsProps> = ({
  treatments,
  heading = 'Related Treatments',
}) => {
  if (!treatments || treatments.length === 0) {
    return null
  }

  return (
    <section className="related-treatments s-pt-30 s-pb-30">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="section-heading">{heading}</h2>
          </div>
        </div>
        <div className="row">
          {treatments.map((treatment, index) => (
            <div key={index} className="col-md-4 col-sm-6">
              <div className="related-treatment-card">
                {treatment.icon && (
                  <div className="treatment-icon">
                    <i className={`fa ${treatment.icon}`} aria-hidden="true" />
                  </div>
                )}
                {treatment.imageUrl && (
                  <div className="treatment-image">
                    <img
                      src={treatment.imageUrl}
                      alt={treatment.name}
                      loading="lazy"
                    />
                  </div>
                )}
                <h3 className="treatment-name">
                  <Link to={`/${treatment.slug}`}>{treatment.name}</Link>
                </h3>
                <p className="treatment-description">{treatment.description}</p>
                <Link to={`/${treatment.slug}`} className="btn btn-outline-primary">
                  Learn More
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default RelatedTreatments
